import React from 'react';

import classes from './installPics.css';

import Pic1 from '../../../../../../assets/logo-color.png';

const ACDCLogo
 = () => (
     <div className={classes.installImages}>
         <img alt="Solvana Logo" src={Pic1} className={classes.installImg} />
     </div>
 );


export default ACDCLogo;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/ACDCLogo.js